<template>
  <a11y-dialog
      @dialog-ref="assignDialogRef"
      app-root="#iteration-messages"
      close-button-label="Close"
      dialog-root="#membership-modal-root"
      id="app-dialog"
      :class-names="{document: 'c-modal a11y-modal c-modal--membership-upsells'}"
  >
    <div class="c-modal__wrap" v-html="content"></div>

    <template v-slot:title>
      <span v-html="title"></span>
    </template>

    <template v-slot:closeButtonContent>
      <i class="fal fa-times" aria-hidden="true"></i> <span>Close</span>
    </template>

  </a11y-dialog>
</template>

<script>
import {EventBus} from "../event-bus"
import {A11yDialog} from "vue-a11y-dialog"

export default {
  name: "Modal",
  components: {
    "a11y-dialog": A11yDialog
  },
  data() {
    return {
      dialog: null,
      content: '',
      title: '',
      contentCache: {},
      isOpen: false
    }
  },
  mounted() {
    EventBus.$on('open-modal', this.updateContent)

    EventBus.$on('open-modal-with-error', this.updateContentWithError)
  },
  methods: {
    addToBasket(element) {
      element.addEventListener('click', e => {
        e.preventDefault()
        const button = e.target
        button.classList.add('active')

        fetch(`${window.env.TNEW_BASE_URL}/api/session/sessionkey`, {
          credentials: 'include'
        })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            throw new Error('Could not fetch cookie from TNEW API.')
          }
        }).then(response => {
          const data = JSON.parse(e.target.dataset.membershipUpsellsLink)
          data.action = 'basethemeMembershipUpsellsAddToBasket'
          data.encryptedSessionKey = response.encryptedSessionKey

          const addToBasketEvent = new CustomEvent('membership-upsells.add-membership-to-basket', {
            detail: {
              data: data,
              callback: response => {

                if (response.hasOwnProperty('sessionDetails')) {

                  const session = response.sessionDetails
                  // Add session data into local storage
                  if ("LoginInfo" in session) {
                    const date = new Date()

                    const sessionInformation = {
                      details: session,
                      expiresAt: date.setMinutes(date.getMinutes() + 20)
                    }
                    localStorage.setItem('sessionData', JSON.stringify(sessionInformation))
                    window.ModeOfSaleId = parseInt(session.ModeOfSaleId)
                    window.isLoggedIn = true
                  }

                  const updateMosEvent = new CustomEvent('update-mode-of-sale', {
                    detail: {
                      modeOfSaleId: session.ModeOfSaleId,
                      callback: data => {
                        if (data.success) {
                          console.log(`ModeOfSaleId: ${session.ModeOfSaleId}`)
                        }
                      }
                    }
                  })

                  document.dispatchEvent(updateMosEvent)

                  // Fire event to unlock booking button
                  const updateBookingButtons = new Event('update-booking-buttons')
                  document.dispatchEvent(updateBookingButtons)

                  // success message
                  button.classList.remove('active')
                  button.innerHTML = '<i class="fal fa-tick" aria-hidden="true"></i> Basket updated'

                  // Close modal on success
                  setTimeout(() => {
                    this.dialog.hide()
                  }, 1000)

                  // REMINDER: remove modal trigger in page and then when rendering upsells we cross check membership MOS with currentMOS
                  // if they are in the array then hide all the modal trigger buttons

                  EventBus.$emit('membership-added-to-basket--success')
                } else if (response.hasOwnProperty('error')) {
                  button.classList.remove('active')
                  const buttonContainer = button.closest('.c-membership-upsell-button-container')
                  const errorMessageContainer = buttonContainer.querySelector('.c-membership-upsell-button-container__error')
                  errorMessageContainer.style.display = 'block'
                  errorMessageContainer.querySelector('.c-membership-upsell__link-error').innerHTML = response.error
                }
              }
            }
          })

          document.dispatchEvent(addToBasketEvent)
        })
        .catch(error => console.log(error))


      })
    },
    assignDialogRef(dialog) {
      this.dialog = dialog;
      this.dialog.on('show', (dialogEl, event) => {
        const modalWrap = dialogEl.querySelector('.c-modal__wrap')
        modalWrap.scrollTo(0,0)
        document.body.classList.add('modal-open')
        this.isOpen = true

        // add a click event listener when the dialog is displayed
        document.addEventListener('click', this.addModalEvents, true)
        this.$parent.isLoading = false
      });

      this.dialog.on('hide', (dialogEl, event) =>{
        const modalWrap = dialogEl.querySelector('.c-modal__wrap')
        modalWrap.scrollTo(0,0)
        document.body.classList.remove('modal-open')

        // remove the click event listener when the dialog is removed in order for the dialog to keep
        // showing when loading the same modal due to the click handler always being present if
        // left to persist
        document.removeEventListener('click', this.addModalEvents, true)
        this.isOpen = false
        this.$parent.isLoading = false
      });
    },
    addModalEvents(event) {
      if (!event.target.closest('.c-modal--membership-upsells')) {
        this.dialog.hide()
      } else if (event.target.matches('.c-membership-upsell__link')) {
        this.addToBasket(event.target)
      }
    },
    updateContentWithError() {
      this.title = 'Error'
      this.content = errorMessage
      this.$parent.isLoading = false
      this.openDialog()
    },
    updateContent(content) {
      this.content = content
      this.openDialog()
    },
    openDialog() {
      this.dialog.show()
    },
  }

}
</script>

<style scoped>

</style>
